import { Loader2 } from "lucide-react";

export default function LoadingState({ label = "Loading…" }) {
    return (
        <div className="flex flex-col items-center justify-center py-24 text-zinc-500" data-testid="loading-state">
            <Loader2 className="h-6 w-6 animate-spin" />
            <div className="mt-3 text-xs tracking-[0.2em] uppercase">{label}</div>
        </div>
    );
}
